// removed by extract-text-webpack-plugin
module.exports = {"container":"_2E4QmuHJ07vd6B2kVv1-pP"};


//////////////////
// WEBPACK FOOTER
// ./src/components/spinner/styles.css
// module id = 956
// module chunks = 0